import React, { useRef, useEffect } from 'react'
import ReactDOM from 'react-dom';
import ModalWindow from '../../../layout/modalwindow/ModalWindow'
import CloseButton from '../../../layout/close_button/CloseButton'
import SelectPaperSizeFormStyle from './css/SelectPaperSizeFormStyle'

function Content(props) {
  const button8pInchRef = useRef(null)

  const onClick = (e) => {
    props.cbf(e.target.id)
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
  }

  useEffect(() => { button8pInchRef.current.focus() }, [])

  return (
    <React.Fragment>
      <div className='option-buttons-container'>
        <button ref={button8pInchRef} id='8.5inch' onClick={onClick} className='selection top-anchor'>
          Print w(8.5inch)
        </button>
        <button id='58mm' onClick={onClick} className='selection'>
          Print w(58mm)
        </button>
      </div>
      <SelectPaperSizeFormStyle />
    </React.Fragment>
  )
}

function SelectPaperSizeHeader() {
  const  onClick = () => { ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container')) }

  return (
    <div className="select-papersize-header">
      <div className='spsh'>Select Paper Size</div>
      <CloseButton id='close-button' onClick={onClick} className='bottom-anchor' title='close'/>
      <SelectPaperSizeFormStyle />
    </div>
  )
}

export function selectPaperSizeForm(cbf) {
  ReactDOM.render (
    <ModalWindow
      id='mw-parent'
      width='35'
      header={<SelectPaperSizeHeader />}
      footer={null}>
      <Content cbf={cbf}/>
    </ModalWindow>,
    document.getElementById('modal-form-container')
  )
}
